<template>
  <div class="top-desciption">
    <el-descriptions
      label-class-name="node-lable"
      content-class-name="node-content"
      title="货主流程配置"
    >
      <el-descriptions-item label="货主名称">
        {{ customersDetail.customerName }}
      </el-descriptions-item>
      <el-descriptions-item label="货主编码">
        {{ customersDetail.customerCode }}
      </el-descriptions-item>
      <el-descriptions-item label="租户名称">
        {{ customersDetail.carrierTenantName }}
      </el-descriptions-item>
      <el-descriptions-item label="企业名称">
        {{ customersDetail.corpName }}
      </el-descriptions-item>
      <el-descriptions-item label="企业社会信用代码">
        {{ customersDetail.creditCode }}
      </el-descriptions-item>
      <el-descriptions-item label="租户编码">
        {{ customersDetail.carrierTenantId }}
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
export default {
  name: 'NodeTop',
  components: {
  },
  props: {
    customersDetail: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.top-desciption{
  padding:24px;
  box-sizing:border-box;
  background: #fff;
  margin-bottom:16px;
  .configure{
    color:#059E84;
    cursor:pointer;
  }
}
::v-deep .el-descriptions{
  .el-descriptions__header{
    margin-bottom:16px;
  }
  .el-descriptions--small{
    font-size: 14px;
  }
  .el-descriptions-item {
    .el-descriptions-item__label{
      color: #404B5C
    }
    .el-descriptions-item__content{
      color:#000F25
    }
  }
}
::v-deep .el-drawer{
  width: 560px !important;
}
</style>
